export default "__VITE_ASSET__Qw3eUcv1__"